__turbopack_context__.v({
  "badge": "Badge-module__QciRyG__badge",
  "closeButton": "Badge-module__QciRyG__closeButton",
  "error": "Badge-module__QciRyG__error",
  "icon": "Badge-module__QciRyG__icon",
  "info": "Badge-module__QciRyG__info",
  "label": "Badge-module__QciRyG__label",
  "lg": "Badge-module__QciRyG__lg",
  "md": "Badge-module__QciRyG__md",
  "neutral": "Badge-module__QciRyG__neutral",
  "primary": "Badge-module__QciRyG__primary",
  "removable": "Badge-module__QciRyG__removable",
  "secondary": "Badge-module__QciRyG__secondary",
  "sm": "Badge-module__QciRyG__sm",
  "square": "Badge-module__QciRyG__square",
  "success": "Badge-module__QciRyG__success",
  "warning": "Badge-module__QciRyG__warning",
  "xs": "Badge-module__QciRyG__xs",
});
